import { RentalPortalViewingPreviewModal } from '../../RentalPortalViewingPreviewModal'

export function useRentalPortalViewingPreview({
  setModal,
  onClose,
  onEntityChange,
}) {
  function handleOpenViewingPreview(viewingId) {
    setModal(
      <RentalPortalViewingPreviewModal
        viewingId={viewingId}
        onClose={onClose}
        onEntityChange={onEntityChange}
      />
    )
  }

  return { handleOpenViewingPreview }
}
